import { render } from "./VideoScreen.vue?vue&type=template&id=4a9926b3"
import script from "./VideoScreen.vue?vue&type=script&lang=js"
export * from "./VideoScreen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Jett\\Desktop\\bg-insieme\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__